export const SynonymObjectId = 'Synonym';

export enum SynonymObjectAttributes {
  TITLE = 'title',
  SYNONYMS = 'synonyms',
}
